import Card from './card'

const TeamList = ({ teamList }) => {
  const base = 'grow grid grid-cols-2 lg:grid-cols-3 gap-[30px] mt-smallMobile md:mt-0'

  return (
    <div className={base}>
      {teamList.map((team, id) => (
        <Card
          key={id}
          photo={team.photo}
          name={team.name}
          position={team.position}
        />
      ))}
    </div>
  )
}

export default TeamList
